import React from "react";

export type NearpayReceipt = {
  merchant?: {
    name?: { arabic?: string; english?: string };
    address?: { arabic?: string; english?: string };
    id?: string;
    category_code?: string;
  };
  start_date?: string;
  start_time?: string;
  card_scheme_sponsor?: string;
  tid?: string;
  system_trace_audit_number?: string;
  pos_software_version_number?: string;
  retrieval_reference_number?: string;
  card_scheme?: { name?: { arabic?: string; english?: string } };
  transaction_type?: { name?: { arabic?: string; english?: string } };
  pan?: string;
  card_expiration?: string;
  amount_authorized?: {
    label?: { arabic?: string; english?: string };
    value?: string;
  };
  currency?: { arabic?: string; english?: string };
  status_message?: { arabic?: string; english?: string };
  is_approved?: boolean;
  verification_method?: { arabic?: string; english?: string } | string;
  approval_code?: {
    value?: string;
    label?: { arabic?: string; english?: string };
  };
  end_date?: string;
  end_time?: string;
  thanks_message?: { arabic?: string; english?: string };
  save_receipt_message?: { arabic?: string; english?: string };
  entry_mode?: string;
  application_identifier?: string;
  terminal_verification_result?: string;
  cardholader_verfication_result?: string;
  application_cryptogram?: string;
  cryptogram_information_data?: string;
  kernel_id?: string;
};

export const generateNearpayReceiptHTML = (r: NearpayReceipt): string => {
  const ar = (s?: string) => s ?? "";
  const en = (s?: string) => s ?? "";
  const vmAr =
    typeof r.verification_method === "string"
      ? r.verification_method
      : r.verification_method?.arabic;
  const vmEn =
    typeof r.verification_method === "string"
      ? r.verification_method
      : r.verification_method?.english;

  return `<!doctype html>
<html dir="rtl" lang="ar">
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1"/>
<style>
  @page { size: 58mm auto; margin: 0; }
  html,body{margin:0;padding:0;background:#fff;color:#000;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  body{
    width:58mm;
    box-sizing:border-box;
    padding:6px 6px 10px;
    font-family: Tahoma, Arial, sans-serif;
    line-height:1.28;
  }
  .c{text-align:center}
  .row{display:flex;justify-content:space-between;align-items:center;margin:4px 0}
  .grid4{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:2px;margin-top:4px}
  .bold{font-weight:700}
  .xs{font-size:10px}
  .sm{font-size:12px}
  .md{font-size:14px}
  .lg{font-size:16px}
  .mono{font-family: "Courier New", ui-monospace, monospace}
  .eng{direction:ltr; unicode-bidi:embed;}
  .muted{opacity:.92}
  .mt4{margin-top:6px}
  .mt6{margin-top:8px}
  .mt8{margin-top:10px}
  hr{border:none;border-top:1px solid #000;margin:8px 0}
  .dash{border-top:1px dashed #000}
  .dot{font-size:14px; line-height:1; margin:2px 0}
</style>
</head>
<body>

  <!-- رأس الإيصال -->
  <div class="c md bold">${
    ar(r.merchant?.name?.arabic) || "شركة بندر بن عبدالحي كردي"
  }</div>
  <div class="c sm eng bold">${
    en(r.merchant?.name?.english) || "Bandar Bin Abdalhai Krdy A"
  }</div>
  <div class="c xs">${
    ar(r.merchant?.address?.arabic) || "وادي منحب ع اسيد"
  }</div>
  <div class="c xs eng">${
    en(r.merchant?.address?.english) || "wadi mnhnab asaid st"
  }</div>

                                               <!-- الصف الأول: الوقت (يمين) والتاريخ (شمال) -->
      <div class="row xs">
        <div class="eng">${en(r.start_time) || "14:43:36"}</div>
        <div>${ar(r.start_date) || "02/09/2025"}</div>
      </div>

    <!-- الصف الثاني: tid (شمال) و merchant.id (يمين) و card_scheme_sponsor (يمين) -->
    <div class="row xs">
      <div class="eng">${en(r.tid) || "6574986540999247"}</div>
      <div class="eng">${en(r.merchant?.id) || "770900099247"}</div>
      <div class="eng">${en(r.card_scheme_sponsor) || "INMA"}</div>
    </div>

    <!-- الصف الثالث: retrieval_reference_number (شمال) و pos_software_version_number (يمين) و system_trace_audit_number (يمين) و category_code (يمين) -->
    <div class="row xs">
      <div class="eng">${
        en(r.retrieval_reference_number) || "102465313000"
      }</div>
      <div class="eng">${en(r.pos_software_version_number) || "1.0.0"}</div>
      <div class="eng">${en(r.system_trace_audit_number) || "000154"}</div>
      <div class="eng">${en(r.merchant?.category_code) || "7542"}</div>
    </div>

    <!-- card_scheme: الإنجليزية (يمين) والعربية (شمال) -->
    <div class="row xs">
      <div>${ar(r.card_scheme?.name?.arabic) || "مدى"}</div>
      <div class="eng">${en(r.card_scheme?.name?.english) || "mada"}</div>
    </div>

    <!-- transaction_type: العربية (يمين) والإنجليزية (شمال) -->
    <div class="row xs">
      <div>${ar(r.transaction_type?.name?.arabic) || "شراء"}</div>
      <div class="eng">${
        en(r.transaction_type?.name?.english) || "PURCHASE"
      }</div>
    </div>

    <!-- pan (يمين) و card_expiration (شمال) -->
    <div class="row xs">
      <div class="eng">${en(r.card_expiration) || "29/12"}</div>
      <div class="eng">${en(r.pan) || "4847 83** **** 7130"}</div>
    </div>

         <!-- مبلغ الشراء (يمين) و value (شمال) -->
     <div class="row xs">
       <div>${ar(r.amount_authorized?.label?.arabic) || "مبلغ الشراء"}</div>
       <div class="eng">${en(r.amount_authorized?.value) || "40.00"}</div>
     </div>

    <!-- PURCHASE AMOUNT (يمين) و value + ريال (شمال) -->
    <div class="row xs">
      <div class="eng">${en(r.amount_authorized?.value) || "40.00"} ريال</div>
      <div class="eng">${
        en(r.amount_authorized?.label?.english) || "PURCHASE AMOUNT"
      }</div>
    </div>

   <!-- status_message.arabic (وسط) -->
   <div class="c xs">${ar(r.status_message?.arabic) || "مقبولة"}</div>

   <!-- status_message.english (وسط) -->
   <div class="c xs eng">${en(r.status_message?.english) || "Approved"}</div>

   <!-- verification_method.arabic (وسط) -->
   <div class="c xs">${ar(vmAr) || "لا يتطلب التحقق"}</div>

   <!-- verification_method.english (وسط) -->
   <div class="c xs eng">${en(vmEn) || "NO VERIFICATION REQUIRED"}</div>

                                                               <!-- رمز الموافقة (يمين) و approval_code.value (شمال) -->
       <div class="row xs">
         <div>${ar(r.approval_code?.label?.arabic) || "رمز الموافقة"}</div>
         <div class="eng">${en(r.approval_code?.value) || "906356"}</div>
       </div>

     <!-- approval_code.value (يمين) و Approval Code (شمال) -->
     <div class="row xs">
       <div class="eng">${en(r.approval_code?.value) || "906356"}</div>
       <div class="eng">${
         en(r.approval_code?.label?.english) || "Approval Code"
       }</div>
     </div>

         <!-- end_time (يمين) و end_date (شمال) -->
     <div class="row xs">
       <div class="eng">${en(r.end_time) || "14:43:36"}</div>
       <div class="eng">${en(r.end_date) || "02/09/2025"}</div>
     </div>

   <!-- thanks_message.arabic (وسط) -->
   <div class="c xs">${
     ar(r.thanks_message?.arabic) || "شكرًا لاستخدامكم مدى"
   }</div>

   <!-- thanks_message.english (وسط) -->
   <div class="c xs eng">${
     en(r.thanks_message?.english) || "Thank you for using mada"
   }</div>

   <!-- save_receipt_message.arabic (وسط) -->
   <div class="c xs">${
     ar(r.save_receipt_message?.arabic) || "يرجى الاحتفاظ بالفاتورة"
   }</div>

   <!-- save_receipt_message.english (وسط) -->
   <div class="c xs eng">${
     en(r.save_receipt_message?.english) || "please retain receipt"
   }</div>

       <!-- **نسخة العميل** (وسط) -->
    <div class="c xs mt8">** نسخة العميل **</div>

    <!-- **Customer Copy** (وسط) -->
    <div class="c xs eng" style="margin-bottom: 8px;">** Customer Copy **</div>

                               <!-- البيانات التقنية: entry_mode + action_code + application_identifier + terminal_verification_result -->
      <div class="c xs eng mono">${en(r.entry_mode) || "CONTACTLESS"}  000  ${
    en(r.application_identifier) || "A0000002282010"
  }  ${en(r.terminal_verification_result) || "0000000000"}</div>

      <!-- البيانات التقنية: transaction_state_information + cardholader_verfication_result + cryptogram_information_data + application_cryptogram + kernel_id -->
      <div class="c xs eng mono">0000  ${
        en(r.cardholader_verfication_result) || "1F0000"
      }  ${en(r.cryptogram_information_data) || "80"}  ${
    en(r.application_cryptogram) || "3EB83FE8F272E316"
  }  ${en(r.kernel_id) || "02"}</div>

  <div class="c bold xs mt8">Powered By NearPay</div>
</body>
</html>`;
};

/* معاينة اختيارية (لا تستخدم في الطباعة المباشرة) */
const NearpayReceipt: React.FC<{ receipt: NearpayReceipt }> = () => null;
export default NearpayReceipt;
